import { Text } from './Text/Text';
import { Title } from './Title/Title';
export var Typography = {
    Title: Title,
    Text: Text
};
